import { render, staticRenderFns } from "./ProblemAddresses.vue?vue&type=template&id=c866a546"
import script from "./ProblemAddresses.vue?vue&type=script&lang=js"
export * from "./ProblemAddresses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports